import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatesWithDividerComponent } from './dates-with-divider.component';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { TimezoneModule } from '../timezone/timezone.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [DatesWithDividerComponent],
  imports: [CommonModule, IntrackFeatureModule, TimezoneModule, SvgIconModule],
  exports: [DatesWithDividerComponent],
})
export class DatesWithDividerModule {}
